import React from 'react';

const ColumnBreak = () => {
  return (
    <div 
      className="mp-menu-sub column-break"
    />
  )
}

export default ColumnBreak;
